import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { compilePath } from '../../utils/helpers/routes';
import Icon from '../icon/Icon';
import './AddPlaceButton.scss';

const addRootLink = (loc) => ({
  pathname: compilePath('add-root'),
  search: loc.search,
});

export interface AddPlaceButtonProps
  extends ComponentPropsWithoutRef<ElementType<any>> {
  className?: string;
}

const AddPlaceButton = ({ className, ...props }: AddPlaceButtonProps) => (
  <Link
    to={addRootLink}
    className={classnames('add-place-button', className)}
    {...props}
  >
    <span className="add-place-button__icon">
      <Icon name="pin" />
    </span>
    <span className="add-place-button__text">Add a place to the map</span>
  </Link>
);

export default AddPlaceButton;
